module.exports = __webpack_public_path__ + "img/prim.1f80be05.png";